import AdminUserList from "./components/admin/AdminUserList";
import AdminPlanList from "./components/admin/AdminPlanList";
import AdminGroupList from "./components/admin/AdminGroupList";
import AdminProjectList from "./components/admin/AdminProjectList";
import AdminNotificationList from "./components/admin/AdminNotificationList";
import AdminPolicyList from "./components/admin/AdminPolicyList";
import AdminUserView from "./components/admin/AdminUserView";
import AdminCreditRequestList from "./components/admin/AdminCreditRequestList";
import AdminPlanView from "./components/admin/AdminPlanView";
import AdminGroupView from "./components/admin/AdminGroupView";
import AdminProjectView from "./components/admin/AdminProjectView";
import AdminNotificationView from "./components/admin/AdminNotificationView";
import AdminPolicyView from "./components/admin/AdminPolicyView";
import AdminPlanCreate from "./components/admin/AdminPlanCreate";
import AdminNotificationCreate from "./components/admin/AdminNotificationCreate";
import AdminPolicyCreate from "./components/admin/AdminPolicyCreate";

export const AdminRouter = {
    routes: [{
        path: '/admin/',
        component: AdminUserList,
    }, {
        path: '/admin/userList',
        component: AdminUserList,
    }, {
        path: '/admin/userView/:userId',
        component: AdminUserView,
    }, {
        path: '/admin/planList',
        component: AdminPlanList,
    }, {
        path: '/admin/groupList',
        component: AdminGroupList,
    }, {
        path: '/admin/projectList',
        component: AdminProjectList,
    }, {
        path: '/admin/notificationList',
        component: AdminNotificationList,
    }, {
        path: '/admin/policyList',
        component: AdminPolicyList,
    }, {
        path: '/admin/planView/:planId',
        component: AdminPlanView,
    }, {
        path: '/admin/planCreate/:userId',
        component: AdminPlanCreate,
    }, {
        path: '/admin/planCreate',
        component: AdminPlanCreate,
    }, {
        path: '/admin/notificationCreate',
        component: AdminNotificationCreate,
    }, {
        path: '/admin/policyCreate',
        component: AdminPolicyCreate,
    }, {
        path: '/admin/groupView/:groupId',
        component: AdminGroupView,
    }, {
        path: '/admin/projectView/:projectId',
        component: AdminProjectView,
    }, {
        path: '/admin/notificationView/:notificationId',
        component: AdminNotificationView,
    }, {
        path: '/admin/policyView/:policyId',
        component: AdminPolicyView,
    }, {
        path: '/admin/creditRequestList',
        component: AdminCreditRequestList,
    }]
};